R$ Total<template>

  <div class="pneu-lancamento ml-4 mr-4" >

      <div class="row">
      <div class="col-7">
        <div class="col-12">
          <div>
                <b-row> 


                      
                        <b-row class="mt-3 mb-3">
                          <!-- Coluna de Tamanho 8 -->
                          <b-col cols="8" >
                            <b-row >
                              <!-- Componente de Imagem com Altura e Largura Definidas -->
                              <b-col cols="3" class="d-flex align-items-center">
                                <img
                                  :src="venda.foto  ? venda.foto : funcionarios.foto_perfil ? funcionarios.foto_perfil : 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/sem-foto.jpg'"
                                  alt="Imagem"
                                  class="img-custom"
                                >
                              </b-col>

                              <!-- Inputs ao lado da Imagem, empilhados verticalmente -->
                              <b-col cols="9">
                                <b-row >
                                  <b-col cols="6">
                                    <b-form-group class="mb-3">
                                      <b-form-input @keyup.enter="loadFuncionario(),loadNovoNroTicket()"  v-model="venda.re" required placeholder="Nº de RE" ></b-form-input>              
                                    </b-form-group>
                                  </b-col>  

                          <b-col cols="6" class="mb-3">
                          <b-input-group-text>
                            {{ 'Saldo liberado.: ' + formatCurrency2(saldo.valor_liberado) }}
                          </b-input-group-text>
                        </b-col>

       
                                </b-row>
                      <b-row class="g-3"> <!-- Função -->
                        <b-col cols="6" class="mb-3">
                          <b-input-group-text>
                            {{ venda.funcao ? venda.funcao : funcionarios.funcao ? funcionarios.funcao : '-' }}
                          </b-input-group-text>
                        </b-col>

                        <b-col cols="6" class="mb-3">
                    <b-input-group-text
                      :style="{
                        backgroundColor: funcionarios.condicao === 'DESLIGADO' ? 'yellow' : '',
                        color: funcionarios.condicao === 'DESLIGADO' ? 'red' : ''
                      }"

                    >
                      <!-- Situação -->
                      {{ venda.condicao ? venda.condicao : funcionarios.condicao ? funcionarios.condicao : '-' }}
                    </b-input-group-text>

                        </b-col>

<b-col cols="12">
  <div v-if="funcionarios.condicao === 'DESLIGADO'" class="alert-container">
    <b-alert show dismissible variant="danger" class="full-width-alert text-center custom-alert-text">
      Funcionário Demitido!
    </b-alert>
  </div>
</b-col>



                      </b-row>

                                <b-row >              
                                      <b-col cols="12" class="mb-3">
                                          <b-input-group-text> <!-- Situação -->
                                            {{ venda.nome ? venda.nome : funcionarios.nome ? funcionarios.nome : '-' }}
                                          </b-input-group-text>
                                        </b-col>
                                </b-row>
                                
                              </b-col>
                            </b-row>
                          </b-col>

                          <!-- Coluna de Tamanho 4 -->
                          <b-col cols="4">
                            <b-row >
                              <!-- Labels com fundo amarelo -->
                              <b-col cols="5" class="d-flex align-items-center">
                                  <b-card                          
                                    class="ml-2"
                                      style="width: 33rem; height: 150px;"
                                    border-variant="primary"
                                    header="Nº ticket"
                                    header-bg-variant="primary"
                                    header-text-variant="white"
                                    align="center"

                                  >
                                    <b-card-text> 
                                      <h2>                    
                                      {{ nroTicket ? nroTicket :  venda.ticket_id ? venda.ticket_id : '-' }}
                                      </h2>
                                    </b-card-text>
                                  </b-card>
                              </b-col>
                              <b-col cols="7" class="d-flex align-items-center">
                                              <b-card                          
                                    class="ml-2"
                                      style="width: 33rem; height: 150px;"
                                    border-variant="primary"
                                    header="R$ Total"
                                    header-bg-variant="primary"
                                    header-text-variant="white"
                                    align="center"

                                  >
                                    <b-card-text> 
                                      <h2 id='cardvalorticket'>                    
                                                                                      {{ parseFloat(ticketitens
    .map(v => parseFloat(v.valor_total) || 0) // Garantir que cada valor seja um número
    .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0) // Somar os valores
).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
}) }}
                                      
                                      </h2>
                                    </b-card-text>
                                  </b-card>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                      


                        <!-- produto  -->
                        
                          
<b-col cols="12">
  <hr id='divisao'> <!-- Linha horizontal -->
</b-col>


                        
                          <!-- Coluna de Tamanho 8 -->
                          <b-col cols="12" >
                                
                            <b-row >
                              <!-- FOTO DO PRODUTO -->
                              
                              <b-col cols="3" class="d-flex align-items-center">
                                <img
                                  :src="venda.foto  ? venda.foto : materiais.foto_thumbnail ? materiais.foto_thumbnail : 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/sem-foto.jpg'"
                                  alt="Imagem"
                                  class="img-custom"
                                >
                              </b-col>

                              <!-- CODIGO DO PRODUTO -->
                              <b-col cols="9">
                                <b-row >
                                  <b-col cols="2">
                                    <label  for="input-busca">Código</label> 
                                    <b-form-group class="mb-3">
                                      <b-form-input @keyup.enter="loadProdutos()" v-model="venda.codigo_erp" required placeholder="Produto" v-b-tooltip.hover title="Digite o número do produto"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>

                                  <!-- DESCRIÇÃO DO PRODUTO -->
                                  <b-col cols="7" class="mb-3">
                                    <label  for="input-busca">Descrição</label> 
                                    <b-input-group-text>
                                      {{ venda.descricao ? venda.descricao : materiais.descricao ? materiais.descricao : '-' }}
                                    </b-input-group-text>
                                  </b-col>

                                  <b-col cols="3">
                                    <label  for="input-busca"></label> 
                                      <b-button class="mt-2 mb-3" variant="primary" block  @click="showModal" >Grid Produto</b-button>
                                    </b-col>        

                                    <div>
                                      <ConsultaMaterial :visible.sync="isModalVisible" />
                                  </div>


                                </b-row>

                                <!-- CODIGO JB -->
                                <b-row class="g-3"> <!-- Função -->
                                  <b-col cols="4" class="mb-3">
                                    <label  for="input-busca">Código produção</label> 
                                    <b-input-group-text>
                                      {{ venda.codigo_producao ? venda.codigo_producao : materiais.codigo_producao ? materiais.codigo_producao : '-' }}
                                    </b-input-group-text>
                                  </b-col>

                                <!-- CODIGO PRODUÇÃO -->  
                                <b-col cols="4" class="mb-3">
                                  <label  for="input-busca">Tamanho</label> 
                                <b-input-group-text
                                
                                >
                                <!-- Situação -->
                                  {{ venda.tamanho ? venda.tamanho : materiais.tamanho ? materiais.tamanho : '-' }}
                                </b-input-group-text>

                                  </b-col>

                                  
                                <!-- CODIGO PRODUÇÃO -->  
                                <b-col cols="4" class="mb-3">
                                  <label  for="input-busca">Cor</label> 
                                <b-input-group-text
   
                                >
                                <!-- TAMANHO -->
                                  {{ venda.cor ? venda.cor : materiais.cor ? materiais.cor : '-' }}
                                </b-input-group-text>

                                  </b-col>




                                </b-row>

                                <!-- QUANTIDADE VALOR -->
                                <b-row >
                                  <b-col cols="4">
                                    <label  for="input-busca">Quantidade</label> 
                                    <b-form-group class="mb-3">
                                      <b-form-input v-model="venda.quantidade" required placeholder="Quantidade" v-b-tooltip.hover title="Digite a quantidade do produto"></b-form-input>              
                                    </b-form-group>                                    
                                  </b-col>

                                  <!-- VALOR UNITÁRIO -->
                                  <b-col cols="4" class="mb-3">
                                    <label  for="input-busca">R$ Valor Unitário</label> 
                                    <b-input-group-text v-mask="'#.###,##'">
                                      {{ venda.valor_venda ? venda.valor_venda : materiais.valor_venda ? formatCurrency2(materiais.valor_venda )  : '-' }}
                                    </b-input-group-text>
                                  </b-col>

                                  <!-- TOTAL --->
                                  <b-col cols="4" class="mb-3">
                                    <label  for="input-busca">R$ Valor Total</label> 
                                    <b-input-group-text v-mask="'#.###,##'">
                                      {{ materiais.valor_venda  ?  formatCurrency2(valorTotal) : '-' }}
                                    </b-input-group-text>
                                  </b-col>


                                </b-row>

                                
                              </b-col>
                            </b-row>
                          </b-col>
                          
                  <b-col cols="12">
                    <b-form-textarea                   
                      id="infoConteudo"
                      v-model="venda.observacao"
                      size="sm"
                      rows="1"            
                      placeholder="Observações"                      
                    ></b-form-textarea>
                  </b-col>

                        
                        

                <b-col cols="9">
                  <b-button class="mt-3 mb-3" variant="primary" block  @click=" postTicketCabecalho(),postTicketItens()">Gravar</b-button>
                </b-col>


                <b-col cols="3">
                  <b-button class="mt-3 mb-3" variant="warning" block  @click="$refs.modalIntegracaoFunanceiro.show()">Finalizar venda</b-button>
                </b-col>
                



          <div class="col-12">
          <!--tbl de dados -->
          <b-table id="tbldefeitos"  small hover striped sticky-header="660px"  :items="ticketitens" :fields="vendasItens" >  

            <template #cell(valor_total)="data">
              {{ formatCurrency2(data.item.valor_total) }}
            </template>


            <template slot="cell(actions)" slot-scope="data"  >
              <b-button @click="editTicketItens(data.item) " v-b-modal.modal-multi-pneu title="Editar itens do ticket"  size="sm" variant="success" class="mr-2">                
                  <i class="fa fa-exclamation-circle"></i>
              </b-button>            
            </template>  
          </b-table>
        </div>





<!--

                    <b-col cols="2" class="mb-2 mt-6">
      <label for="input-registro">DINHEIRO</label> 
      <NumericInput
        v-model="venda.dinheiro"  
        placeholder=""
        title="Digite o valor recebido em dinheiro"
        :disabled="venda.tipopagto_id != 5"
      />
    </b-col>

    <b-col cols="2" class="mb-2 mt-6">
      <label for="input-registro">DÉBITO</label> 
      <NumericInput
        v-model="venda.debito"  
        placeholder=""
        title="Digite o valor recebido em débito"
        :disabled="venda.tipopagto_id != 1"        
      />
    </b-col> 

    <b-col cols="2" class="mb-2 mt-6">
      <label for="input-registro">PIX</label> 
      <NumericInput
        v-model="venda.pix"  
        placeholder=""
        title="Digite o valor recebido em pix"
        :disabled="venda.tipopagto_id != 3"
      />
    </b-col> 

    <b-col cols="2" class="mb-2 mt-6">
      <label for="input-registro">CRÉDITO</label> 
      <NumericInput
        v-model="venda.credito"  
        placeholder=""
        title="Digite o valor recebido em cartão"
        :disabled="venda.tipopagto_id != 2"
      />
    </b-col> 

    <b-col cols="2" class="mb-2 mt-6">
      <label for="input-registro">FOLHA</label> 
      <NumericInput
        v-model="venda.vale"  
        placeholder=""
        title="Digite o valor recebido em folha"
        :disabled="venda.tipopagto_id != 4"
      />
    </b-col>


                                 <b-col cols="2" class="mt-0">
                                          <label for="input-registro">TOTAL</label> 
                                          <b-input-group-text> 
                                          {{ parseFloat(ticketitens
    .map(v => parseFloat(v.valor_total) || 0)
    .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0) 
).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
}) }}
                                          </b-input-group-text>
                                </b-col>
-->


  

            </b-row>


            <b-row>
              

              <!--  GERAR PDF -->
         
              <!--
                <b-col cols="3">
                  <b-button class="mt-3 mb-3" variant="warning" block  @click=" postPneus()">Gerar PDF</b-button>
                </b-col>
-->
              
            </b-row>




                
              </div>




        </div>
      </div>


      <div class="col-5">     
              <b-row class="justify-content-center align-items-center">

        <b-card-group class="ml-3 mt-3 mb-3 d-flex justify-content-center" deck>

          

              <b-card                          
                class="ml-2"
                style="width: 33rem;"
                border-variant="primary"
                header="QUANTIDADE DE TICKET"
                header-bg-variant="primary"
                header-text-variant="white"
                align="center"

              >
                <b-card-text> 
                  <h2>                    
                  {{ distinctTicketIdCount }}     
                  </h2>
                </b-card-text>
              </b-card>
            
            <b-card                  
              class="ml-2"
              style="width: 33rem;"              
              border-variant="primary"
              header="ITENS"
              header-bg-variant="primary"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                  {{ ticketitenscard.length }}
                </h2>               
                
              </b-card-text>
            </b-card>

            <b-card                  
            class="ml-2"
                style="width: 33rem;"
              
              border-variant="success"
              header="VALOR R$"
              header-bg-variant="success"
              header-text-variant="white"
              align="center"
            >
              <b-card-text> 
                <h2>
                                              {{ parseFloat(ticketitenscard
    .map(v => parseFloat(v.valor_total) || 0) // Garantir que cada valor seja um número
    .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0) // Somar os valores
).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
}) }}

                  
                </h2>                
              </b-card-text>
      </b-card>        




      </b-card-group> 

      
                <b-col cols="12"  class="mb-3">
                <label  for="input-busca">Pesquisa no grid</label> 
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Pesquisar por Nº do ticket ou registro do funcionário"></b-form-input>              
              </b-col>        

      

      </b-row> 
        <!--  TABLE DE DADOS                               -->
        <div class="col-12">
          <!--tbl de dados -->
          <b-table id="tbldefeitos"  small hover striped sticky-header="660px"  :items="itemsFiltered" :fields="vendasSintetico" >    

            <template #cell(total)="data">
              {{ formatCurrency2(data.item.total) }}
            </template>

            
            <template slot="cell(actions)" slot-scope="data"  >
              <b-button @click="editTicketItens(data.item) " v-b-modal.modal-multi-pneu title="Editar ticket"  size="sm" variant="success" class="mr-2">                
                  <i class="fa fa-exclamation-circle"></i>
              </b-button>            
          </template>           
          </b-table>
        </div>
      </div>
    </div>

            <!-- Modal Saldo -->
<div>
  <b-modal ref="modalMultiPreventivaPecas" id="modal-multi-preventivaPecas" cancel-title="Fechar" size="xl" title="Controle de saldo disponível" no-close-on-esc no-close-on-backdrop>
    <font color="blue">{{ 'Saldo liberado.: ' + formatCurrency2(saldo.valor_liberado) }}</font>
    <div>
      <b-table v-model="tablepecas" small hover striped sticky-header="530px" :fields="campoSaldoDisponivel" :items="saldofuncionario">
        <template #cell(valor)="data">
          {{ formatCurrency2(data.item.valor) }}
        </template>
      </b-table>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" block variant="outline-primary" @click="cancel()">
        Voltar
      </b-button>
    </template>
  </b-modal>
</div>


<!-- Modal financeiro -->
<div>
  <b-modal ref="modalIntegracaoFunanceiro" id="modal-multi-preventivaPecas" cancel-title="Fechar" size="xl" title="Integração financeira" no-close-on-esc no-close-on-backdrop>
    <font color="blue"></font>
    <div>

      <b-row>

        
                
                <b-col cols="4">
                    <label for="input-chassifabricante">FORMA DE PAGAMENTO</label>
                    <div>                
                      <b-form-select                  
                        v-model="venda.tipopagto_id"  
                        required                                                   
                        :options="tipopagtos"
                        class="mb-3"
                        text-field="tipo"                            
                      >                   
                      </b-form-select>

                    </div>
                </b-col>  

                <b-col cols="4">
                    <label for="input-chassifabricante">PARCELAS</label>
                    <div>                
                      <b-form-select                  
                        v-model="venda.parcela_id"  
                        required                                                   
                        :options="parcelas"
                        class="mb-3"
                        text-field="parcela"                                            
                      >                   
                      </b-form-select>

                    </div>
                </b-col>


                <b-col cols="2">                 
                  <label for="input-chassifabricante"></label>
                  <b-button class="mt-2" variant="success" block  @click="     postFinanceiroParcelas(),postTicketCabecalho()">FINALIZAR</b-button>                  
                </b-col>               

                <b-col cols="2">
                     <label for="input-chassifabricante"></label>
                  <b-button class="mt-1 mb-3" variant="warning" block  @click="loadParcelasFolha(), gerarPDFLesser()">Gerar PDF</b-button>
                </b-col>


      </b-row>

     
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" block variant="outline-primary" @click="cancel()">
        Voltar
      </b-button>
    </template>
  </b-modal>
</div>



      


    
  </div>  

</template>

<script>
import { baseApiUrl, showError  } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import VueTheMask from 'vue-the-mask';
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'
import NumericInput from '../utilitarios/NumericInput';
import ConsultaMaterial from '../sambaiba/CF7MaterialConsulta';
import jsPDF from 'jspdf';
//import 'jspdf-autotable';


export default {

    name: 'ManutencaoRfiLancamento', 
    
    
    computed : { ... mapState (['user'],),
      itemsFiltered(){
        let valores = [];
       // const values = Object.values(obj);
        valores = this.ticketsintetico.filter((item) =>{
          return (
            item.re.indexOf(this.search) >-1  ||
            item.ticket_id.indexOf(this.search) >-1  
          );
        });
        return valores
        },
        valorTotal() {
          return this.materiais.valor_venda ? (this.materiais.valor_venda * this.venda.quantidade + 0.00) : 0.00;
        },
        formattedValue() {
          return this.formatCurrency(this.venda.folha);
        },

            distinctTicketIdCount() {
      return [...new Set(this.ticketitenscard.map(item => item.ticket_id))].length;
    },

formattedTotal() {
  // Verifica se ticketitens é um array
  if (!Array.isArray(this.ticketitens)) {
    console.error('ticketitens não é um array');
    return 0;
  }

  // Calcula o total somando os valores válidos
  const total = this.ticketitens
    .map(v => {
      const valor = parseFloat(v.valor_total);
      return isNaN(valor) ? 0 : valor; // Substitui valores inválidos por 0
    })
    .reduce((acumulador, valorAtual) => acumulador + valorAtual, 0.00);

  return total; // Retorna o total
}






    } ,


    data: function() {
      
      return {

        ///CF7 - 01/08/2024 as 21:58h
        isModalVisible: false,
        vendas:[],
        venda:{},
        vendasitens:[],
        vendaitem:{},
        formapagtos:[],
        funcionarios:[],
        funcionario:{},
        financeiros:[],
        materiais:[],
        tipopagtos:[],
        nroTicket : 0,
        ticketsintetico:[],
        ticketitens:[],
        ticketitenscard:[],
        parcelas:[],
        parcelasfolha:[],
        saldofuncionario:[],
        saldo:[],
        //////////////
        pneus:[],               
        pneu:{},
        filiais:[],
        fabricantes:[],
        vidas:[],
        borrachas:[],
        carcacas:[],
        statuss:[],
        pneussaldo:[],
        value_fornecedor:0,
        fornecedores:[],
        





        isLoading: false,
        dt_abertura: '',
            empresas:[],
            filiais:[],

            empresasf:[],
            empresaf:{},
            filialf:{},
            pneus:[],
            operador:[],            
            socorrista_carro:[],
            trocado_carro:[],
            socorristas:[],
            pneus:[],
            pneu:{},
            viacep:[],

            value_empresaf: [],



            defeitos:[],
            defeito:{},

            gruposi:[],
            subgruposi:[],
            defeitosi:[],
            
            gruposd:[],
            subgruposd:[],
            defeitosd:[],

            executante:{},
            executantes: [],  
            lider:{},
            lideres:[],





            mode: 'save',
            carregando: false,
            atualizando: false, 

            
            
            

            
            
            grupo:{},
            grupos:[],
            subgrupo:{},
            subgrupos:[],
            defeito:{},
            defeitos:[],

                        
           // gruposd:[],
            gruposd:{},
            subgrupod:{},
            subgruposd:[],
            defeitod:{},


            solicitante:{},
            solicitantes:[],


            socorrista:{},
            linhas:[],

            nropneu:[],

            pneueditdefeito:[],
            
            

            situacaojb:[],

            value_carro:'',
            value_carro_socorrista:'',
            value_carro_trocado:'',
            value_cep:'',
            value_solicitante:'',
            value_executante:'', 
            value_socorrista:'',           
            value_status:[],
            value_statusjb:[],
            value_tipo:[],
            value_lider:'',
            

            //garagem:{},             
            tipos:[] ,
            search:'',


            

            lin:{},
            
            value_garagem:[],// [] lista                         
            
            
            value_observacoes:'',
           
          //  barra_inicial: 0,         
          //  barra_limite: 300000,
            
            vendasSintetico: [      
                 
  //            { key: 'empresa_id', label: 'Empresa', sortable: true },                 
              { key: 'filial_id', label: 'Filial', sortable: true },   
               { key: 'dt_cadastro', label: 'Data lançamento', sortable: true, formatter: (value, key, ticketsintetico) => {
                    return moment(ticketsintetico.dt_cadastro).format('DD/MM/YYYY - HH:mm').replace('Data inválida','-') ; }  },              
              { key: 'ticket_id', label: 'Nrº ticket', sortable: true },  
              { key: 're', label: 'Funcionário', sortable: true },                                
              { key: 'funcao', label: 'Função', sortable: true },              
              { key: 'total', label: 'R$ Total', sortable: true },     
              { key: 'tipo', label: 'Tipo de Pagamento', sortable: true },                              
//              { key: 'id', label: 'Integrado', sortable: true },                              
              { key: 'actions', label: 'Ações' },                
              
            ],

              campoSaldoDisponivel: [      
                 
              { key: 're', label: 'Registro', sortable: true },                 
              { key: 'funcao', label: 'Função', sortable: true },   
               { key: 'dt_vencimento', label: 'Data Vencimento', sortable: true, formatter: (value, key, saldofuncionario) => {
                    return moment(saldofuncionario.dt_vencimento).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },              
              { key: 'valor', label: 'R$ Total', sortable: true },     
              
              
            ],


            //////// VENDA PRODUTOS
            vendasItens: [                
                { key: 'id', label: 'Item', sortable: true },                 
                { key: 'codigo_erp', label: 'Código', sortable: true },                                                
                { key: 'descricao', label: 'Descrição', sortable: true },                 
                { key: 'quantidade', label: 'Quantidade', sortable: true },                
                { key: 'valor_total', label: 'Valor unitário', sortable: true },                                
                { key: 'valor_total', label: 'Valor Total', sortable: true },                                                
                //{ key: 'defeito_cancelado', label: 'Cancelado', sortable: true,formatter: value => value ? 'Sim' : 'Não'  },     
                { key: 'actions', label: 'Ações' },                
            ]


        }        
    },

    filters: {
      dataFormatada(dt) {
        return dt.substring(0,4)
      }

    },

    components: {
        Multiselect,LoadingModal,VueTheMask,NumericInput,ConsultaMaterial
    },


    methods: {

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

      showModal() {
        this.isModalVisible = true;
      },



//////cf7
        formatCurrency2(amount) {
      const number = parseFloat(amount);
      if (isNaN(number)) {
        return 'R$ 0,00'; // Valor padrão se não for um número
      }
      return number.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    },


      async loadFuncionario() { 
            let corpo = {                             
            "registro": `${this.venda.re}`,
            "id_empresa": `${this.user.id_empresa}`
            };             
          const url = `${baseApiUrl}/jb/folha/funcionario/listagem`
          axios.post(url,corpo)
              .then(res => { this.funcionarios = res.data })    
              this.loadComprasFuncionario()              
              //this.reset()
//              this.loadNovoNroTicket()         
      },  

      async loadProdutos() { 
            let corpo = {                             
            //"empresa_id": `${this.materiais.empresa_id}`,
            "codigo_erp": `${this.venda.codigo_erp}`,
            "filtro": 'CF7'
            };             
          const url = `${baseApiUrl}/sambaiba/cf7/produto`
          axios.post(url,corpo)
              .then(res => { this.materiais = res.data })             
      }, 

      
      loadNovoNroTicket() {
            const url = `${baseApiUrl}/sambaiba/cf7/nroticket`
            axios.post(url).then(res => {
              this.nroTicket = 0
              this.reset()
              this.nroTicket = res.data.rows[0].nextval
            })
      },


loadComprasFuncionario() {
  // Obtém a data atual no formato YYYY-MM-DD
  const dataAtual = new Date().toISOString().split('T')[0];

  let corpo = {
    "empresa_id": `${this.user.id_empresa}`,
    "re": `${this.venda.re}`,
    "dtAtual": dataAtual,  // Define a data atual no formato YYYY-MM-DD
    "filtro": "saldodisponivel"
  };

  const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
  axios.post(url, corpo)
    .then(res => {
      this.saldofuncionario = res.data;  // Atualiza os dados do saldo
      this.loadSaldoLiberado()
      
      // Abre o modal
      this.$refs.modalMultiPreventivaPecas.show(); // Chama o modal usando a referência
    })
    .catch(showError);
},

loadSaldoLiberado() {
  // Obtém a data atual no formato YYYY-MM-DD
  const dataAtual = new Date().toISOString().split('T')[0];

  let corpo = {
    "empresa_id": `${this.user.id_empresa}`,
    "re": `${this.venda.re}`,
    "dtAtual": dataAtual,  // Define a data atual no formato YYYY-MM-DD
    "filtro": "saldo"
  };

  const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
  axios.post(url, corpo)
    .then(res => {
      this.saldo = res.data;  // Atualiza os dados do saldo
      
      
      
    })
    .catch(showError);
},

       ///Tipo de pagamento
        loadTipoPagto() {   
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                                           
          };          
          const url = `${baseApiUrl}/sambaiba/cf7/tipopagto`
          axios.get(url)
               .then(res => {this.tipopagtos = res.data.map(sb => {return { ... sb, value: sb.id, tipo: sb.tipo} })})
               .catch(showError)
        },

        loadParcelas() {   
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                                           
          };          
          const url = `${baseApiUrl}/sambaiba/cf7/parcelas`
          axios.get(url)
               .then(res => {this.parcelas = res.data.map(sb => {return { ... sb, value: sb.id, tipo: sb.parcela} })})
               .catch(showError)
        },

  formatCurrency(value) {
    if (!value) return '';
    value = value.toString().replace(/\D/g, ''); // Remove non-digit characters

    // Ensure at least '0'
    value = value.length ? value : '0';

    if (value.length === 1) return `0,0${value}`;
    if (value.length === 2) return `0,${value}`;
    
    const integerPart = value.slice(0, -2);
    const decimalPart = value.slice(-2);
    return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decimalPart;
  },
  convertToDatabaseFormat(value) {
    if (!value) return '0.00';

    // Remove thousand separators (points) and replace the decimal separator (comma) with a dot
    let numericValue = value.toString().replace(/\./g, ''); // Remove all points

    // Find the position of the last comma (if any) and replace it with a dot
    const commaIndex = numericValue.lastIndexOf(',');
    if (commaIndex > -1) {
      numericValue = numericValue.slice(0, commaIndex) + '.' + numericValue.slice(commaIndex + 1);
    } else {
      numericValue += '.00'; // If no comma, add '.00'
    }

    // Ensure at least a zero
    return numericValue || '0.00';
  },




        async postTicketCabecalho() {   
              const formattedCredit = this.convertToDatabaseFormat(this.venda.credito);
            let corpo = {                           
              "id_funcionario": `${this.user.id_funcionario_erp}`,            
              "id": this.nroTicket ? this.nroTicket : this.venda.ticket_id,
              "empresa_id": `${this.funcionarios.id_empresa}`,            
              "filial_id": `${this.funcionarios.id_filial}`,  
              "funcionario_id": `${this.funcionarios.id_funcionario_erp}`,           
              "funcao_id": `${this.funcionarios.id_funcao}`,
              "pix": `${this.venda.pix / 100}`,
              "dinheiro": `${this.venda.dinheiro}`,
              "credito": formattedCredit / 100,
              "debito": `${this.venda.debito / 100}`,
              "vale": `${this.venda.vale / 100}`,    
              "desconto": `${this.venda.desconto / 100}`,    
              "total":  `${this.formattedTotal}`,  
              "tipopagto_id": this.venda.tipopagto_id ? `${this.venda.tipopagto_id}` : null,
              "observacao": this.venda.observacao ? `${this.venda.observacao}` : null,
              "filtro": 'gravar'
                            /*
              "status_id": this.venda.status_id ? `${this.venda.status_id}` : false,
              */
            }; 
          const url = `${baseApiUrl}/sambaiba/cf7/ticketcabecalho`
         axios.post(url,corpo).then(() => {          
           })
           .catch(showError)
      },

          async postTicketItens() {   
              
            let corpo = {                           
              "id_funcionario": `${this.user.id_funcionario_erp}`,            
              "ticket_id":  this.nroTicket ? this.nroTicket : this.venda.ticket_id,
              "id":  this.venda.id ? this.venda.id : null,
              "empresa_id": `${this.funcionarios.id_empresa}`,            
              "filial_id": `${this.funcionarios.id_filial}`,  
              "funcionario_id": `${this.funcionarios.id_funcionario_erp}`,           
              "produto_id": `${this.materiais.id  }`,
              "quantidade": `${this.venda.quantidade}`,
              "tamanho_id": `${this.materiais.tamanho_id}`,
              "cor_id": `${this.materiais.cor_id}`,
              "valor_unitario": `${ parseFloat(this.materiais.valor_venda)}`,                            
              //"desconto": `${this.parseFloat(this.venda.desconto)}`,    
              "valor_total": `${ parseFloat(this.materiais.valor_venda) * parseInt(this.venda.quantidade) }`,    
              "status_id": true,           // true-ativo  / false-cancelado
              "observacao": `${this.venda.observacao}`,
              "rotina_id": 1,
              "filtro": 'gravar'
                         
            }; 
          const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`
         axios.post(url,corpo).then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadTicketItensCard()
          this.loadTicketItens()          
          this.loadTicketSintetico()
          this.reset()
           })
           .catch(showError)
      },


      async postFinanceiroParcelas() {                 
            let corpo = {                           
              "id_funcionario": `${this.user.id_funcionario_erp}`,            
              "ticket_id": this.nroTicket ? this.nroTicket : this.venda.ticket_id,
              "empresa_id": `${this.funcionarios.id_empresa}`,            
              "filial_id": `${this.funcionarios.id_filial}`,  
              "funcionario_id": `${this.funcionarios.id_funcionario_erp}`,           
              //"dt_emissao": `${this.funcionarios.id_funcao}`,
              //"dt_vencimento": `${this.funcionarios.id_funcao}`,              
              "parcela_id": `${this.venda.parcela_id}`,
              "tipopagto_id": `${this.venda.tipopagto_id}`,              
              "total":  `${this.formattedTotal}`,                                 
              "filtro": 'gravarparcelas'
            }; 
          const url = `${baseApiUrl}/sambaiba/cf7/financeiro`
         axios.post(url,corpo).then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadTicketSintetico()
          this.loadParcelasFolha()
          //this.postTicketItens()          
          //this.reset()
           })
           .catch(showError)
      },




  loadTicketSintetico() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,        
        "filtro": "lancamentodia"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/ticketcabecalho`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.ticketsintetico = res.data;  // Atualiza os dados do pneu                
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                ticketsintetico = {};                
            }
        })
        .catch(showError);
  },

  loadTicketItens() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,        
        "ticket_id": this.nroTicket ? `${this.nroTicket}` :`${this.venda.ticket_id}`,
        "filtro": "lancamentodia"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.ticketitens = res.data;  // Atualiza os dados do pneu
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                ticketitens = {};                
            }
        })
        .catch(showError);
  },

    loadTicketItensCard() {
    let corpo = {
        "empresa_id": `${this.user.id_empresa}`,                
        "filtro": "lancamentodiacard"
    };
    const url = `${baseApiUrl}/sambaiba/cf7/ticketcorpo`;
    axios.post(url, corpo)
        .then(res => {
            if (res.status === 200) {  // Verifica se a resposta foi bem-sucedida
                this.ticketitenscard = res.data;  // Atualiza os dados do pneu
            } else if (res.status === 404) {  // Verifica se o pneu não foi encontrado
                ticketitenscard = {};                
            }
        })
        .catch(showError);
  },


async gerarPDFLesser() {
  try {
    const doc = new jsPDF();
    const startX = 14;
    const startY = 10;
    const fontSize = 8; // Defina o tamanho da fonte desejado

    doc.setFontSize(fontSize); // Define o tamanho da fonte para todos os textos seguintes

    // URL da imagem
    const imageUrl = 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/logotipo/LOGO_SAMBAIBA.png';

    // Função para carregar a imagem a partir da URL
    const loadImage = (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = url;
        img.crossOrigin = 'Anonymous'; // Para evitar problemas de CORS
        img.onload = () => resolve(img);
        img.onerror = reject;
      });
    };

    const image = await loadImage(imageUrl);

    // Adicionar tabela com imagem, texto e campos antes do texto 'CF7'
    const tableData = [
      [
        { content: '', image: image, width: 16, height: 16 }, // Primeira coluna: Imagem
        { content: 'CF7 STORE' }, // Segunda coluna: Texto
        {
          content: (this.nroTicket ? 'Nº ticket \n' + this.nroTicket : 'Nº ticket \n' + this.venda.ticket_id) + '\n' +
                   'Data Emissão \n' + moment(this.venda.dt_cadastro).format('DD/MM/YYYY HH:mm') // Formatar a data corretamente
        } // Terceira coluna: Texto
      ]
    ];

    // Adiciona a primeira tabela
    doc.autoTable({
      startY: startY,
      body: tableData,
      columnStyles: {
        0: { cellWidth: 27, halign: 'center', valign: 'middle' }, // Tamanho e alinhamento da coluna 0 (Imagem)
        1: { cellWidth: 115, halign: 'center', valign: 'middle' }, // Tamanho e alinhamento da coluna 1 (Texto)
        2: { cellWidth: 40, halign: 'center', valign: 'middle' }   // Tamanho e alinhamento da coluna 2 (Texto)
      },
      styles: {
        fillColor: [255, 255, 255], // Fundo branco
        textColor: [0, 0, 0], // Texto preto
        lineColor: [0, 0, 0], // Bordas pretas
        halign: 'center', // Centralizar texto horizontalmente
        valign: 'middle' // Centralizar texto verticalmente
      },
      tableLineColor: [0, 0, 0], // Bordas pretas
      tableLineWidth: 0.1, // Largura das bordas
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.raw.image) {
          doc.addImage(data.cell.raw.image.src, 'PNG', data.cell.x + 2, data.cell.y + 2, data.cell.raw.width, data.cell.raw.height);
        }

        // Desenhar linha vertical entre a segunda e terceira colunas
        if (data.column.index === 1) {
          const cell = data.cell;
          doc.setDrawColor(0, 0, 0); // Cor preta para a linha
          doc.setLineWidth(0.1); // Largura da linha
          doc.line(cell.x + cell.width, cell.y, cell.x + cell.width, cell.y + cell.height);
        }
      }
    });

    // Ajuste o valor de startY para a próxima tabela
    const newTableStartY = doc.autoTable.previous.finalY + 10; // 10 é o espaçamento adicional entre as tabelas

    // Adicionar nova tabela com 1 linha e 3 colunas
    const newTableData = [
      ['Registro.:' + this.funcionarios['re'] + '\n' + 'Função.: '+ this.funcionarios['funcao'] + '\n' +  'Nome.: ' + this.funcionarios['nome'] + (this.venda.observacao ? '\n' +  'Observação.: ' + this.venda.observacao : '')]
    ];

    // Posição informações do funcionário
    doc.autoTable({
      startY: newTableStartY - 8,
      body: newTableData,
      columnStyles: {
        0: { cellWidth: 180, halign: 'left' }, // Alinhar coluna 0 (Texto) ao centro
        1: { cellWidth: 1, halign: 'left' }, // Alinhar coluna 1 (Texto) ao centro
        2: { cellWidth: 1, halign: 'left' }  // Alinhar coluna 2 (Texto) ao centro
      },
      styles: {
        fillColor: [255, 255, 255], // Fundo branco
        textColor: [0, 0, 0], // Texto preto
        lineColor: [0, 0, 0], // Bordas pretas
        halign: 'center', // Centralizar texto horizontalmente
        valign: 'middle' // Centralizar texto verticalmente
      },
      tableLineColor: [0, 0, 0], // Bordas pretas
      tableLineWidth: 0.1 // Largura das bordas
    });

    // Adicionar tabela com parcelasfolha
    const parcelasfolhaData = this.parcelasfolha.map(parcela => [
      parcela.parcela || '', // Exemplo de dado
      parseFloat(parcela.valor_parcela).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || '', // Exemplo de dado
      moment(parcela.dt_vencimento).format('DD/MM/YYYY') || '' ,// Exemplo de dado
      parcela.tipo_pagto || '', // Exemplo de dado//tipopagtos
    ]);

    const parcelasfolhaHeaders = ['Parcela', 'Valor', 'Data','Tipo Pagamento'];

    doc.autoTable({
      startY: doc.autoTable.previous.finalY + 50, // TABELA DE PARCELAS
      head: [parcelasfolhaHeaders],
      body: parcelasfolhaData,
      columnStyles: {
        0: { cellWidth: 40, halign: 'center' },
        1: { cellWidth: 40, halign: 'right' },
        2: { cellWidth: 40, halign: 'center' },
        3: { cellWidth: 40, halign: 'center' }
      },
      styles: { fontSize: 8, cellPadding: 2, valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.1 }, // Adicionar bordas pretas
      headStyles: { fontStyle: 'bold' },
      didDrawCell: function (data) {
        const cell = data.cell;
        const doc = data.doc;
        doc.rect(cell.x, cell.y, cell.width, cell.height, 'S'); // Desenhar as bordas
      }
    });

    // Cabeçalhos da tabela
    const headers = ['Item', 'Código', 'Descrição', 'Quantidade', 'Valor unitário', 'Total'];

    // Preparar os dados para o PDF com formatação de moeda
    const dadosParaPDF = this.ticketitens.map((item, index) => {
      const valorUnitario = parseFloat(item.valor_unitario) || 0;
      const quantidade = parseFloat(item.quantidade) || 0;
      const total = valorUnitario * quantidade;
      const totalgeral = valorUnitario * quantidade;

      return [
        index + 1, // Adiciona o índice (começando de 1 para ser mais intuitivo)
        item.codigo_erp || '', // Coluna 2: Código
        item.descricao || '', // Coluna 3: Descrição
        quantidade, // Coluna 4: Quantidade
        valorUnitario.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // Coluna 5: Valor unitário formatado
        total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }), // Coluna 6: Total formatado
        totalgeral
      ];
    });

    // Calcular a soma total geral
    const somaTotal = dadosParaPDF.reduce((acumulador, linha) => {
      // Utiliza linha[5] que contém o total como número não formatado
      const valorTotal = parseFloat(linha[6]) || 0;
      return acumulador + valorTotal;
    }, 0);

    // Adicionar a soma total geral no final
    dadosParaPDF.push([
      'Total Geral', // Texto para a coluna de índice
      '', // Coluna 2: Vazio para o código
      '', // Coluna 3: Vazio para a descrição
      '', // Coluna 4: Vazio para a quantidade
      '', // Coluna 5: Vazio para o valor unitário
      somaTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) // Coluna 6: Total Geral formatado
    ]);

    // Número de linhas por página
    const rowsPerPage = 12;

    for (let i = 0; i < dadosParaPDF.length; i += rowsPerPage) {
      const currentData = dadosParaPDF.slice(i, i + rowsPerPage);

      if (i > 0) {
        doc.addPage();
      }

      doc.autoTable({
        startY: 50,
        head: [headers],
        body: currentData,
        theme: 'plain',
        columnStyles: {
          0: { cellWidth: 20, halign: 'center' }, // Alinhar coluna 0 (Item) ao centro
          1: { cellWidth: 20, halign: 'center' }, // Alinhar coluna 1 (Código) ao centro
          2: { cellWidth: 62, halign: 'left' }, // Alinhar coluna 2 (Descrição) à esquerda
          3: { cellWidth: 20, halign: 'right' }, // Alinhar coluna 3 (Quantidade) à direita
          4: { cellWidth: 30, halign: 'right' }, // Alinhar coluna 4 (Valor unitário) à direita
          5: { cellWidth: 30, halign: 'right' } // Alinhar coluna 5 (Total) à direita
        },
        styles: { fontSize: 8, cellPadding: 2, valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.1 }, // Adicionar bordas pretas
        headStyles: { fontStyle: 'bold' },
        didDrawCell: function (data) {
          const cell = data.cell;
          const doc = data.doc;
          doc.rect(cell.x, cell.y, cell.width, cell.height, 'S'); // Desenhar as bordas
        }
      });
    }

    const pageCount = doc.internal.getNumberOfPages();
    const footerFontSize = 6; // Defina o tamanho da fonte para o rodapé

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      const footerX = 10;
      const footerY = doc.internal.pageSize.height - 10;
      const currentDate = moment().format('DD/MM/YYYY - HH:mm');
      const pageNumber = 'Página ' + i + ' de ' + pageCount;
      const footerText = 'Data: ' + currentDate + ' | ' + pageNumber;

      doc.setFontSize(footerFontSize); // Define o tamanho da fonte
      doc.text(footerText, footerX, footerY);

      // Verifica se estamos na última página
      if (i === pageCount) {
        const assinaturaY = footerY - 10; // Ajuste conforme necessário
        doc.text("____________________________________________________________________", footerX, assinaturaY - 5);
        doc.text("Assinatura: " + this.funcionarios['nome'] + '-' + this.funcionarios['funcao'], footerX, assinaturaY);
      }
    }

    doc.save('Ticket_' + this.venda.ticket_id + '_funcionario_' + this.funcionarios['re'] + '.pdf');
  } catch (error) {
    console.error('Erro ao gerar PDF:', error);
  }
},

      loadParcelasFolha() {         
          let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,        
        "ticket_id": this.nroTicket ? `${this.nroTicket}` :`${this.venda.ticket_id}`,
                          
          };
          const url = `${baseApiUrl}/sambaiba/cf7/financeiro/folha`
          axios.post(url,corpo).then(res => { 
            this.parcelasfolha = res.data  
            }            
          )
          .catch(showError)         
      },






      limparFiltro(){
        this.search= ""
      },

        
      loadEmpresa() {
                    let corpo = {    
                        "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
                    };
        
                  const url = `${baseApiUrl}/ctr/empresa`
                  axios.post(url,corpo)
                  .then(res => {this.empresas = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
                  .catch(showError)
      },
      
      loadFilial() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };
          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo)
          .then(res => {this.filiais = res.data.map(emp => {return { ... emp, value: emp.id_filial_erp, filial: emp.filial, empresa_id: emp.empresa_id } })})
          .catch(showError)
          
      },

              ///CHASSI FABRICANTE
      loadFabricante() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/fabricante`
          axios.post(url,corpo)
               .then(res => {this.fabricantes = res.data.map(gru => {return { ... gru, value: gru.id, fabricante: gru.fabricante} })})
               .catch(showError)          
        }, 

       
        loadVida() {             
          const url = `${baseApiUrl}/pneu/vida`
          axios.get(url)
               .then(res => {this.vidas = res.data.map(sb => {return { ... sb, value: sb.id, vida: sb.vida} })})
               .catch(showError)
        },





              
      loadBorracha() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/borracha`
          axios.post(url,corpo)
               .then(res => {this.borrachas = res.data.map(gru => {return { ... gru, value: gru.id, borracha: gru.borracha} })})
               .catch(showError)          
        }, 


              
      loadCarcaca() {      
            let corpo = {    
                "empresa_id": `${this.user.id_empresa}`,                                            
            };    
          const url = `${baseApiUrl}/pneu/desenho`
          axios.post(url,corpo)
               .then(res => {this.carcacas = res.data.map(gru => {return { ... gru, value: gru.id, desenho: gru.desenho} })})
               .catch(showError)          
        }, 


              
      loadStattus() {        
          const url = `${baseApiUrl}/pneu/status`
          axios.get(url)
               .then(res => {this.statuss = res.data.map(gru => {return { ... gru, value: gru.id, status: gru.status} })})
               .catch(showError)          
        }, 

              ///////////////////////////////// 31/12/2022 as 20:17h
      editTicketResumo(venda){
            this.venda = { ...venda }            
            //this.loadTicketItens()
            this.loadFuncionario()
            //this.loadProdutos()            
      },

      
      ///////////////////////////////// 31/12/2022 as 20:17h
      editTicketItens(venda){
            this.venda = { ...venda }            
            this.loadTicketItens()
            this.loadFuncionario()
            this.loadProdutos()    
            this.loadParcelasFolha()        
      },

      
      loadPneuSaldo() {         
          let corpo = {    
               "empresa_id": `${[this.pneu.empresa_id]}`,                                           
               "filial_id": `${[this.pneu.filial_id]}`,
               "origem" : "websaldo"           
          };
          const url = `${baseApiUrl}/pneu/pneu`
          axios.post(url,corpo).then(res => { 
            this.pneussaldo = res.data  
            }            
          )
          .catch(showError)         
      },
      
     
      reset() {        
        this.ticketitens = []
        this.venda = {}         
      },

      limparCorpo(){
        this.defeito =[]        
        this.executante=[]
       this.lider=[]        
       this.value_executante=''
        this.value_lider=''
        ///this.nropneu=[]  // precisa limpar somente ao fechar ou quando cria-se uma nova ficha
      },

      novo(){
        this.pneu = {}
        this.defeito = {}                
        this.pneueditdefeito = {}     
      },

            loadPneuFornecedores() {
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,
            "origem": 'listagem'
          };
      const url = `${baseApiUrl}/fin/clifor`;
      axios.post(url, corpo)      
            .then(res => {this.fornecedores = res.data.map(gru => {return { ... gru, value: gru.id, nome: gru.nome} })})  
            .catch(showError)          
      },

       
    },
    
    mounted() {   
      this.loadEmpresa() 
      this.loadFilial()
      this.loadTipoPagto() 
      this.loadTicketSintetico()   
      this.loadTicketItensCard()
      this.loadParcelas()
      /*
      this.loadFabricante()      
      this.loadVida()
      this.loadBorracha()      
      this.loadCarcaca()
      this.loadStattus()
      this.loadPneuFornecedores()
      */


    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#placa{
    font-size: 0.7em;      
}


#cardvalorticket{
    font-size: 1.3em;      
}


#modal-multi-pneu___BV_modal_content_{
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;  
}


#defeito-selecao{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;  
}

#id-sos{  
  background: rgb(199, 222, 218);
  border: 1px solid red ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196) ;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-diagnosticado{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#id-encerramento{
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2) ;
  border-radius: 8px;
  margin-bottom: 4px;  
  
}

#pneu-nro{
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
  
}



#garagem{  
  font-size: 12px;
  text-align: center;
  
}



/* Define a altura e a largura da imagem */
.img-custom {
  width: 150px; /* Ajuste conforme necessário */
  height: 150px; /* Ajuste conforme necessário */
  object-fit: cover; /* Garante que a imagem cubra a área sem distorcer */
}


.alert-container {
  position: fixed; /* Fixa o elemento na tela */
  top: 50%; /* Move o elemento para o meio verticalmente */
  left: 50%; /* Move o elemento para o meio horizontalmente */
  transform: translate(-50%, -50%); /* Ajusta a posição para o centro do elemento */
  z-index: 1000; /* Garante que o alerta ficará sobre outros conteúdos */
}

#divisao {
      border: 0;
      height: 4px;
      background: #1405ee; /* Cor da linha */
      margin: 20px 0; /* Espaço acima e abaixo da linha */
    }

.alert-container {
  width: 78%;
  padding: 0;
  margin: 0;
}

.full-width-alert {
  width: 100%;
  box-sizing: border-box; /* Garante que padding e bordas não afetam a largura total */
}

/* Para centralizar o texto no alerta */
.full-width-alert .alert-content {
  text-align: center; 
}

.custom-alert-text {
  font-size: 1.44rem; /* Ajuste o tamanho da fonte conforme necessário */
  text-align: center; /* Garante que o texto está centralizado */
}



</style>